(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bandeau-operation"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vn-op[hidden]').forEach(function (op) {
    var show = op.hasAttribute('data-preview');
    if (!show && op.dataset.start && op.dataset.end) {
      var now = new Date();
      show = now >= new Date(op.dataset.start + 'T00:00:00+01:00') && now <= new Date(op.dataset.end + 'T23:59:59+01:00');
    }
    if (show) op.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calculateur-proteines"]) return;
  try {
    
  (function () {
    'use strict';

    var form = document.getElementById('vn-calc');
    if (!form) return;

    var poidsEl = document.getElementById('calc-poids');
    var minEl = document.getElementById('calc-min');
    var maxEl = document.getElementById('calc-max');
    var ratioEl = document.getElementById('calc-ratio');
    var dosesEl = document.getElementById('calc-doses');
    var mealsEl = document.getElementById('calc-meals');
    var noteEl = document.getElementById('calc-note');

    /* Fourchettes en g de protéines par kg de poids corporel.
       Repères usuels en nutrition sportive ; volontairement donnés en
       fourchette, pas en chiffre unique. */
    var RANGES = {
      sedentaire: [0.8, 1.0],
      entretien: [1.4, 1.8],
      prise_de_masse: [1.6, 2.2],
      seche: [1.8, 2.4]
    };

    var WHEY_PAR_DOSE = 23; /* g de protéines par dose de 30 g */

    function frFloat(n) {
      return String(n).replace('.', form.getAttribute('data-decimal') || ',');
    }

    function objectif() {
      var checked = form.querySelector('input[name="objectif"]:checked');
      return checked ? checked.value : 'entretien';
    }

    function calculer() {
      var poids = parseFloat(poidsEl.value);
      if (isNaN(poids)) poids = 0;
      if (poids < 30) poids = poids === 0 ? 0 : 30;
      if (poids > 250) poids = 250;

      var obj = objectif();
      var r = RANGES[obj] || RANGES.entretien;

      var lo = Math.round(poids * r[0]);
      var hi = Math.round(poids * r[1]);

      minEl.textContent = lo;
      maxEl.textContent = hi;
      ratioEl.textContent = frFloat(r[0]) + ' – ' + frFloat(r[1]);
      dosesEl.textContent = Math.round(lo / WHEY_PAR_DOSE) + ' – ' + Math.round(hi / WHEY_PAR_DOSE);
      mealsEl.textContent = Math.round(lo / 4) + ' – ' + Math.round(hi / 4);
      noteEl.textContent = form.getAttribute('data-note-' + obj) || '';
    }

    form.addEventListener('input', calculer);
    form.addEventListener('change', calculer);
    form.addEventListener('submit', function (e) { e.preventDefault(); });

    calculer();
  })();
  (function () {
    var btn = document.querySelector('.calc__share-copy');
    if (!btn || !navigator.clipboard) return;
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(btn.getAttribute('data-share-url')).then(function () {
        btn.textContent = btn.getAttribute('data-copied');
        setTimeout(function () { btn.textContent = btn.getAttribute('data-label'); }, 2000);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    'use strict';

    function updateHeaderBadge(count) {
      document.querySelectorAll('.vn-header__cart-badge').forEach(function (el) {
        el.textContent = count;
      });
    }

    /* ── Qty update / remove ── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-key][data-cart-qty]');
      if (!btn) return;
      e.preventDefault();
      var key = btn.dataset.cartKey;
      var qty = parseInt(btn.dataset.cartQty, 10);
      if (isNaN(qty) || qty < 0) return;
      btn.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          updateHeaderBadge(d.item_count);
          window.location.reload();
        })
        .catch(function () { btn.disabled = false; });
    });

    /* ── Promo code → applied at checkout via /discount/ ── */
    var promoInput = document.getElementById('vcart-promo');
    var promoApply = document.getElementById('vcart-promo-apply');
    var promoMsg   = document.getElementById('vcart-promo-msg');

    if (promoApply) {
      promoApply.addEventListener('click', function () {
        var code = (promoInput ? promoInput.value : '').trim().toUpperCase();
        if (!code) return;
        /* Show feedback; code is applied on checkout redirect */
        if (promoMsg) {
          /* Le code n'est reellement verifie qu'au paiement : on annonce ce qui va
             se passer, sans laisser croire qu'il est deja reconnu. */
          var tpl = promoMsg.dataset.pending || 'Le code {code} sera verifie et applique au paiement.';
          promoMsg.textContent = tpl.replace('{code}', code);
          promoMsg.className = 'vcart__promo-msg vcart__promo-msg--info';
        }
      });
    }

    /* ── Checkout button ── */
    var checkoutBtn = document.getElementById('vcart-checkout');

    /* ── Barre de commande collante (téléphone) : visible tant que le vrai bouton n'est pas à l'écran ── */
    var sticky = document.getElementById('vcart-sticky');
    if (sticky && checkoutBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) { sticky.removeAttribute('inert'); } else { sticky.setAttribute('inert', ''); }
      }, { threshold: 0 }).observe(checkoutBtn);
      document.getElementById('vcart-sticky-btn').addEventListener('click', function () { checkoutBtn.click(); });
      var mainTotal = document.querySelector('.vcart__total-main');
      var stickyTotal = document.getElementById('vcart-sticky-total');
      if (mainTotal && stickyTotal && 'MutationObserver' in window) {
        new MutationObserver(function () { stickyTotal.textContent = mainTotal.textContent; })
          .observe(mainTotal, { childList: true, characterData: true, subtree: true });
      }
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        var code = promoInput ? promoInput.value.trim().toUpperCase() : '';
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
        } else {
          window.location.href = '/checkout';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    'use strict';

    function updateHeaderBadge(count) {
      document.querySelectorAll('.vn-header__cart-badge').forEach(function (el) {
        el.textContent = count;
        el.classList.remove('is-pulsing');
        void el.offsetWidth;
        el.classList.add('is-pulsing');
      });
    }

    function addToCart(variantId, btn) {
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      var original = btn.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          btn.textContent = btn.dataset.addedLabel || 'Ajouté ✓';
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (d) { updateHeaderBadge(d.item_count); })
            .catch(function () {});
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = original;
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    }

    document.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('[data-atc]');
      if (atcBtn) { e.preventDefault(); addToCart(atcBtn.dataset.atc, atcBtn); return; }

      var notifyToggle = e.target.closest('[data-notify]');
      if (notifyToggle) {
        var id = notifyToggle.dataset.notify;
        var form = document.getElementById('notify-' + id);
        if (!form) return;
        var isHidden = form.hidden;
        form.hidden = !isHidden;
        notifyToggle.setAttribute('aria-expanded', String(isHidden));
        if (isHidden) { var em = form.querySelector('.bc-card__notify-email'); if (em) em.focus(); }
        return;
      }

      var notifySubmit = e.target.closest('[data-notify-submit]');
      if (notifySubmit) {
        var pid = notifySubmit.dataset.notifySubmit;
        var card = notifySubmit.closest('.bc-card');
        var email = card ? card.querySelector('.bc-card__notify-email') : null;
        var msg = document.getElementById('notify-msg-' + pid);
        if (!email || !email.value || !email.value.includes('@')) {
          if (email) email.style.borderColor = '#c97777';
          return;
        }
        if (email) email.style.display = 'none';
        notifySubmit.style.display = 'none';
        if (msg) msg.hidden = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var footer = document.querySelector('.vn-footer');
    if (footer) {
      footer.classList.add('vn-footer--acc');
      footer.querySelectorAll('.vn-footer__toggle').forEach(function (t) {
        t.addEventListener('click', function () {
          var open = t.getAttribute('aria-expanded') !== 'true';
          t.setAttribute('aria-expanded', open ? 'true' : 'false');
          t.closest('.vn-footer__col').classList.toggle('is-open', open);
        });
      });
    }
  })();
  (function () {
    var btn = document.querySelector('[data-cookie-prefs]');
    if (!btn) return;

    function ready() {
      return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    }

    // On n'affiche le bouton que si l'API de banniere Shopify repond vraiment,
    // pour ne jamais laisser un bouton mort dans le pied de page.
    function reveal() {
      if (!ready()) return false;
      btn.hidden = false;
      return true;
    }

    if (!reveal()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (reveal() || tries > 20) clearInterval(timer);
      }, 250);
    }

    btn.addEventListener('click', function () {
      if (ready()) window.privacyBanner.showPreferences();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    'use strict';
    var mq = window.matchMedia('(max-width: 900px)');
    var nav = document.getElementById('vn-nav');
    var burger = document.querySelector('[data-nav-burger]');

    /* Safari iOS n'applique :active (réaction à l'appui) que si un écouteur touchstart existe */
    document.addEventListener('touchstart', function () {}, { passive: true });

    /* Ouverture/fermeture du menu mobile, avec un voile sur la page : appui sur le voile,
       touche Échap ou choix d'un lien referment le menu */
    var scrim = null;
    function setMenu(open, refocus) {
      nav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? burger.dataset.labelClose : burger.dataset.labelOpen);
      if (scrim) scrim.classList.toggle('is-on', open);
      if (!open && refocus) burger.focus();
    }
    if (burger && nav) {
      scrim = document.createElement('div');
      scrim.className = 'vn-nav-scrim';
      scrim.setAttribute('aria-hidden', 'true');
      nav.parentNode.appendChild(scrim);
      scrim.addEventListener('click', function () { setMenu(false); });
      burger.addEventListener('click', function () { setMenu(!nav.classList.contains('is-open')); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) setMenu(false, true);
      });
      nav.addEventListener('click', function (e) {
        if (e.target.closest('a[href]')) setMenu(false);
      });
    }

    /* Accordéon des sous-menus (mobile uniquement, desktop = survol) */
    document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!mq.matches) return;
        e.preventDefault();
        var item = btn.closest('[data-nav-item]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });

    /* Desktop : le sous-menu s'ouvre au survol ou au focus via CSS. On reflète
       cet état dans aria-expanded, sinon un lecteur d'écran annonce « replié »
       pendant que le menu est visible à l'écran. */
    document.querySelectorAll('[data-nav-item]').forEach(function (item) {
      var subBtn = item.querySelector('[data-nav-toggle]');
      if (!subBtn) return;
      function sync(open) {
        if (mq.matches) return; /* mobile : géré par l'accordéon ci-dessus */
        subBtn.setAttribute('aria-expanded', String(open));
      }
      item.addEventListener('mouseenter', function () { sync(true); });
      item.addEventListener('mouseleave', function () { sync(false); });
      item.addEventListener('focusin', function () { sync(true); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) sync(false);
      });
    });

    /* Réinitialise l'état en repassant sur desktop */
    function resetOnDesktop(e) {
      if (e.matches) return;
      if (nav) nav.classList.remove('is-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.classList.remove('is-on');
      document.querySelectorAll('[data-nav-item].is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var t = item.querySelector('[data-nav-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', resetOnDesktop);
    } else if (mq.addListener) {
      mq.addListener(resetOnDesktop);
    }

    /* Barre d'offres : tri des messages selon leurs dates (heure de Paris en hiver), puis défilement */
    var bar = document.querySelector('.vn-announcement[data-rotate]');
    if (bar) {
      var msgs = Array.prototype.slice.call(bar.querySelectorAll('.vn-announcement__msg'));
      var nowDate = new Date();
      var preview = bar.hasAttribute('data-preview-operations');
      var isDated = function (m) { return !!(m.dataset.start || m.dataset.end); };
      var inWindow = function (m) {
        if (!isDated(m) || preview) return true;
        if (m.dataset.start && nowDate < new Date(m.dataset.start + 'T00:00:00+01:00')) return false;
        if (m.dataset.end && nowDate > new Date(m.dataset.end + 'T23:59:59+01:00')) return false;
        return true;
      };
      var wide = window.matchMedia('(min-width: 1000px)').matches;
      var pool = msgs.filter(function (m) { return !(wide && m.hasAttribute('data-mobile-only')); });
      var operations = pool.filter(function (m) { return isDated(m) && inWindow(m); });
      var regular = pool.filter(function (m) {
        if (isDated(m)) return false;
        return !(operations.length && m.hasAttribute('data-hide-op'));
      });
      var active = operations.concat(regular);
      msgs.forEach(function (m) { m.classList.remove('is-active'); });
      if (active.length) {
        var current = 0;
        active[0].classList.add('is-active');
        var rotateMs = parseInt(bar.dataset.rotate, 10) * 1000;
        var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (active.length > 1 && rotateMs && !calm) {
          setInterval(function () {
            if (document.hidden) return;
            var leaving = active[current];
            leaving.classList.remove('is-active');
            leaving.classList.add('is-leaving');
            setTimeout(function () { leaving.classList.remove('is-leaving'); }, 600);
            current = (current + 1) % active.length;
            active[current].classList.add('is-active');
          }, rotateMs);
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var v = document.querySelector('.vn-hero__product-video');
    if (!v) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.removeAttribute('autoplay');
      v.pause();
      return;
    }

    /* Chrome sometimes auto-pauses silent video-only autoplay to save power
       ("video-only background media was paused"), immediately or a few
       seconds in. This decorative loop has no user-facing pause control,
       so any pause is the browser's doing — just resume it whenever it
       happens, plus a couple of early retries while things settle. */
    function attempt() { v.play().catch(function () {}); }
    v.addEventListener('pause', attempt);
    attempt();
    setTimeout(attempt, 1000);
    setTimeout(attempt, 3000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var dialog = document.getElementById('vn-popup');
    if (!dialog) return;

    var STORE_KEY = 'vn-popup';
    var SENT_KEY = 'vn-popup-sent';
    var SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;
    var mobile = window.matchMedia('(max-width: 699px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isSuccess = !!dialog.querySelector('[data-popup-state="success"]');
    var hasError = !!dialog.querySelector('.vn-popup__error');
    var closing = false;

    function readState() {
      try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
    }
    function saveState(state) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify({ state: state, at: Date.now() })); } catch (e) {}
    }
    function takeSentFlag() {
      try {
        var sent = sessionStorage.getItem(SENT_KEY) === '1';
        sessionStorage.removeItem(SENT_KEY);
        return sent;
      } catch (e) { return false; }
    }

    function open() {
      if (dialog.open) return;
      closing = false;
      if (mobile.matches) dialog.show(); else dialog.showModal();
      /* Lecture forcée du style pour que la transition parte de l'état fermé
         (requestAnimationFrame ne tourne pas dans un onglet en arrière-plan). */
      void dialog.offsetWidth;
      dialog.classList.add('is-visible');
    }
    function close(state) {
      if (!dialog.open || closing) return;
      closing = true;
      if (state) saveState(state);
      dialog.classList.remove('is-visible');
      setTimeout(function () { dialog.close(); }, reduceMotion ? 0 : 250);
    }
    function dismiss() { close(isSuccess ? 'subscribed' : 'dismissed'); }

    dialog.querySelectorAll('[data-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', dismiss);
    });
    /* Clic sur le fond (la zone hors du contenu, en mode modal). */
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dismiss(); });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); dismiss(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dialog.open) dismiss(); });

    var form = dialog.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem(SENT_KEY, '1'); } catch (e) {}
      });
    }

    var copyBtn = dialog.querySelector('[data-popup-copy]');
    if (copyBtn) {
      var copyLabel = copyBtn.textContent;
      copyBtn.addEventListener('click', function () {
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(copyBtn.getAttribute('data-popup-copy')).then(function () {
          copyBtn.textContent = copyBtn.getAttribute('data-copied-label');
          setTimeout(function () { copyBtn.textContent = copyLabel; }, 2000);
        });
      });
    }

    /* Éditeur de thème : ouvert seulement quand la section est sélectionnée. */
    if (dialog.hasAttribute('data-design-mode')) {
      var sectionId = dialog.getAttribute('data-section-id');
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail.sectionId === sectionId) open();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.detail.sectionId === sectionId) close();
      });
      return;
    }

    /* Bandeau du haut et bannière « Première commande » : ouvrent le pop-up sur place */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="inscription=1"]');
      if (!a) return;
      e.preventDefault();
      open();
    });
    if (/[?&]inscription=1/.test(location.search)) open();

    var justSent = takeSentFlag();
    if (isSuccess) {
      /* Inscrit (ici ou via la newsletter du bas de page) : plus jamais proposé.
         On n'ouvre le code que si l'envoi vient du pop-up. */
      saveState('subscribed');
      if (justSent) open();
      return;
    }
    if (justSent && hasError) {
      open();
      return;
    }

    var saved = readState();
    if (saved && saved.state === 'subscribed') return;
    if (saved && saved.state === 'dismissed' && Date.now() - saved.at < SNOOZE_MS) return;

    function isVisible(el) {
      if (!el) return false;
      var style = getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && el.getBoundingClientRect().height > 0;
    }
    /* Bandeau cookies sans réponse : sur mobile on attend (le panneau et le
       bandeau se partageraient le bas de l'écran) ; sur ordinateur on attend
       30 s, puis la modale passe au-dessus. */
    var BANNER_WAIT_MS = 30000;
    var bannerWaitUntil = null;
    function bannerInTheWay() {
      if (!isVisible(document.getElementById('shopify-pc__banner'))) return false;
      if (mobile.matches) return true;
      if (bannerWaitUntil === null) bannerWaitUntil = Date.now() + BANNER_WAIT_MS;
      return Date.now() < bannerWaitUntil;
    }
    function somethingInTheWay() {
      if (document.getElementById('vn-intro')) return true;
      if (bannerInTheWay()) return true;
      if (document.querySelector('.vn-header__nav.is-open')) return true;
      if (document.querySelector('dialog[open]:not(#vn-popup)')) return true;
      return false;
    }

    var triggered = false;
    function attempt() {
      if (triggered) return;
      if (somethingInTheWay()) {
        setTimeout(attempt, 1500);
        return;
      }
      triggered = true;
      open();
    }

    var delay = (parseInt(dialog.getAttribute('data-delay'), 10) || 10) * 1000;
    /* la photo se charge pendant l'attente, pour être là dès l'ouverture */
    setTimeout(function () {
      dialog.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }, Math.max(0, delay - 6000));
    setTimeout(attempt, delay);

    /* Intention de sortie (souris vers les onglets), pas avant 4 s sur la page. */
    if (!mobile.matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.clientY > 0) return;
        if (performance.now() < 4000) return;
        attempt();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offres-du-moment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    document.querySelectorAll('[data-vof]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.vof__item'));
      var preview = root.hasAttribute('data-preview-operations');
      var now = new Date();
      function dated(m) { return !!(m.dataset.start || m.dataset.end); }
      function inWindow(m) {
        if (preview) return true;
        if (m.dataset.start && now < new Date(m.dataset.start + 'T00:00:00+01:00')) return false;
        if (m.dataset.end && now > new Date(m.dataset.end + 'T23:59:59+01:00')) return false;
        return true;
      }
      /* une opération = une offre qui a un début ; une offre qui n'a qu'une fin reste à sa place */
      function operation(m) { return !!m.dataset.start; }
      var op = items.some(function (m) { return operation(m) && inWindow(m); });
      items.forEach(function (m) {
        m.hidden = !(dated(m) ? inWindow(m) : !(op && m.hasAttribute('data-hide-op')));
      });
      /* l'opération en cours passe en premier */
      var track = root.querySelector('[data-vof-track]');
      items.filter(function (m) { return operation(m) && !m.hidden; }).reverse().forEach(function (m) { track.prepend(m); });
      var shown = Array.prototype.slice.call(track.querySelectorAll('.vof__item:not([hidden])'));
      if (!shown.length) { root.hidden = true; return; }

      /* compte à rebours jusqu'à la fin de l'offre (23 h 59, heure de Paris) */
      var timers = shown.map(function (m) {
        var el = m.querySelector('[data-vof-left]');
        return el ? { el: el, box: el.parentNode, end: new Date(m.dataset.end + 'T23:59:59+01:00').getTime() } : null;
      }).filter(Boolean);
      function pad2(n) { return n < 10 ? '0' + n : String(n); }
      function countdown() {
        timers.forEach(function (t) {
          var left = Math.max(0, Math.floor((t.end - Date.now()) / 1000));
          t.el.textContent = t.el.dataset.format
            .replace('[d]', Math.floor(left / 86400))
            .replace('[h]', pad2(Math.floor(left % 86400 / 3600)))
            .replace('[m]', pad2(Math.floor(left % 3600 / 60)))
            .replace('[s]', pad2(left % 60));
          t.box.hidden = left === 0;
        });
      }
      if (timers.length) { countdown(); setInterval(countdown, 1000); }

      var dotsBox = root.querySelector('[data-vof-dots]');
      var dots = shown.map(function (m, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vof__dot';
        b.setAttribute('aria-label', String(i + 1));
        b.addEventListener('click', function () { go(i); hold(); });
        dotsBox.appendChild(b);
        return b;
      });
      if (shown.length < 2) dotsBox.hidden = true;

      function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function go(i) {
        var n = (i + shown.length) % shown.length;
        track.scrollTo({ left: shown[n].offsetLeft - track.offsetLeft, behavior: calm ? 'auto' : 'smooth' });
      }
      function sync() {
        var i = Math.min(index(), shown.length - 1);
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      var prev = root.querySelector('[data-vof-prev]'), next = root.querySelector('[data-vof-next]');
      if (prev) prev.addEventListener('click', function () { go(index() - 1); hold(); });
      if (next) next.addEventListener('click', function () { go(index() + 1); hold(); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();

      /* défilement tout seul, comme la vitrine des pots : il ne s'arrête qu'après un geste
         (flèches, points, doigt), ou quand la section n'est pas à l'écran ; le trait doré
         du point actif se remplit pendant la durée de la bannière */
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var seconds = parseFloat(root.dataset.seconds) || 4.5;
      root.style.setProperty('--vof-s', seconds + 's');
      var visible = false, resumeAt = 0, timer = null, last = -1;
      function hold() { resumeAt = Date.now() + 8000; root.classList.add('is-held'); schedule(); }
      track.addEventListener('touchstart', hold, { passive: true });
      root.addEventListener('focusin', hold);
      function schedule() {
        clearTimeout(timer);
        if (calm || shown.length < 2) return;
        var wait = Math.max(seconds * 1000, resumeAt - Date.now());
        timer = setTimeout(function () {
          if (!visible || document.hidden) { schedule(); return; }
          root.classList.remove('is-held');
          go(index() + 1);
        }, wait);
      }
      /* chaque nouvelle bannière repart pour une durée complète */
      track.addEventListener('scroll', function () {
        var i = index();
        if (i !== last) { last = i; schedule(); }
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: .25 }).observe(track);
      } else { visible = true; }
      schedule();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var form = document.querySelector('.vcontact__form');
    if (!form) return;

    var hp = document.getElementById('contact-website');
    var check = document.getElementById('contact-check');
    var loadedAt = Date.now();

    /* Marqueur posé dès le chargement : un robot qui poste directement
       sur l'URL sans ouvrir la page ne l'aura pas. */
    if (check) check.value = 'humain';

    form.addEventListener('submit', function (e) {
      /* 1. Pot de miel rempli = robot */
      if (hp && hp.value !== '') {
        e.preventDefault();
        return;
      }

      /* 2. Envoi trop rapide pour avoir été écrit à la main */
      var seconds = Math.round((Date.now() - loadedAt) / 1000);
      if (seconds < 4) {
        e.preventDefault();
        return;
      }

      /* 3. On horodate pour pouvoir repérer les envois suspects a posteriori */
      if (check) check.value = 'humain-' + seconds + 's';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var items = document.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      var answer = item.querySelector('[data-faq-answer]');
      var icon   = item.querySelector('[data-faq-icon]');
      if (!toggle || !answer) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        /* Close all others */
        items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) {
            other.classList.remove('is-open');
            var otherAnswer = other.querySelector('[data-faq-answer]');
            var otherToggle = other.querySelector('[data-faq-toggle]');
            if (otherAnswer) {
              otherAnswer.style.maxHeight = '0';
              otherAnswer.setAttribute('inert', '');
            }
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          item.classList.remove('is-open');
          answer.style.maxHeight = '0';
          answer.setAttribute('inert', '');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          answer.removeAttribute('inert');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-partenaires"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    /* Onglets des profils (téléphone) */
    var tabs = document.querySelectorAll('[data-vpart-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.getAttribute('data-vpart-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        document.querySelectorAll('[data-vpart-profile]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-vpart-profile') === i);
        });
      });
    });

    var form = document.querySelector('.vpart__form');
    if (!form) return;
    var select = document.getElementById('vpart-type');

    /* Le bouton d'un profil présélectionne le bon type dans le formulaire */
    document.querySelectorAll('[data-partner-type]').forEach(function (link) {
      link.addEventListener('click', function () {
        var value = link.getAttribute('data-partner-type');
        if (select && value) select.value = value;
      });
    });

    /* Anti-spam, comme sur la page contact */
    var hp = document.getElementById('vpart-website');
    var check = document.getElementById('vpart-check');
    var loadedAt = Date.now();
    if (check) check.value = 'humain';
    form.addEventListener('submit', function (e) {
      if (hp && hp.value !== '') { e.preventDefault(); return; }
      var seconds = Math.round((Date.now() - loadedAt) / 1000);
      if (seconds < 4) { e.preventDefault(); return; }
      if (check) check.value = 'humain-' + seconds + 's';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partenaires-equipe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    document.querySelectorAll('[data-vpt]').forEach(function (root) {
      var track = root.querySelector('[data-vpt-track]');
      var prev = root.querySelector('[data-vpt-prev]'), next = root.querySelector('[data-vpt-next]');
      if (!track || !prev) return;
      function step() { var first = track.querySelector('.vpt__item'); return first ? first.offsetWidth + 16 : track.clientWidth; }
      function sync() {
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    'use strict';

    /* ── Gallery ── */
    var galleries = document.querySelectorAll('[data-gallery]');
    galleries.forEach(function (gallery) {
      var slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var mainEl = gallery.querySelector('.vprod__main');
      var current = 0;
      var total = slides.length;
      if (!total) return;

      function activate(idx) {
        if (idx < 0) idx = total - 1;
        if (idx >= total) idx = 0;
        slides[current].classList.remove('is-active');
        if (thumbs[current]) {
          thumbs[current].classList.remove('is-active');
          thumbs[current].setAttribute('aria-pressed', 'false');
        }
        current = idx;
        slides[current].classList.add('is-active');
        if (thumbs[current]) {
          thumbs[current].classList.add('is-active');
          thumbs[current].setAttribute('aria-pressed', 'true');
          thumbs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { activate(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { activate(current + 1); });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activate(parseInt(thumb.dataset.galleryThumb, 10));
        });
      });

      /* Swipe */
      if (mainEl) {
        var sx = null;
        mainEl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        mainEl.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 50) activate(dx < 0 ? current + 1 : current - 1);
          sx = null;
        }, { passive: true });
      }

      /* Ordinateur : glisser à deux doigts sur le pavé tactile, ou cliquer sur un côté de la photo.
         La vue 3D garde la souris pour tourner le pot. */
      if (mainEl && total > 1) {
        var onModel = function () { return slides[current].classList.contains('vprod__slide--model'); };

        /* Un geste = une image : l'élan du pavé envoie encore des événements, on attend qu'il s'arrête */
        var wheelSum = 0;
        var wheelLock = false;
        var wheelTimer = null;
        mainEl.addEventListener('wheel', function (e) {
          if (onModel() || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          e.preventDefault();
          clearTimeout(wheelTimer);
          wheelTimer = setTimeout(function () { wheelSum = 0; wheelLock = false; }, 200);
          if (wheelLock) return;
          wheelSum += e.deltaX;
          if (Math.abs(wheelSum) > 40) {
            activate(wheelSum > 0 ? current + 1 : current - 1);
            wheelLock = true;
          }
        }, { passive: false });

        var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        var sideOf = function (e) {
          var box = mainEl.getBoundingClientRect();
          return e.clientX - box.left < box.width / 2 ? 'prev' : 'next';
        };
        mainEl.addEventListener('click', function (e) {
          if (!finePointer.matches || onModel() || e.target.closest('button, a, model-viewer')) return;
          activate(sideOf(e) === 'prev' ? current - 1 : current + 1);
        });
      }
    });

    /* ── Variant select → update price + ATC ── */
    var variantSelect = document.getElementById('vprod-variant-select');
    var priceEl = document.getElementById('vprod-price');
    var atcBtn = document.getElementById('vprod-atc');

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (atcBtn) {
          var avail = opt.dataset.available === 'true';
          atcBtn.disabled = !avail;
          atcBtn.textContent = avail ? (atcBtn.dataset.labelAdd || atcBtn.textContent) : (atcBtn.dataset.labelOos || atcBtn.textContent);
        }
        /* Show the variant's own photo in the gallery */
        if (opt.dataset.mediaPos !== undefined) {
          var thumb = document.querySelector('[data-gallery-thumb="' + opt.dataset.mediaPos + '"]');
          if (thumb) thumb.click();
        }
      });

      /* Radio buttons → update hidden select */
      var radios = document.querySelectorAll('.vprod__opt-radio');
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          /* Build option values from all checked radios */
          var vals = {};
          document.querySelectorAll('.vprod__opt-radio:checked').forEach(function (r) {
            vals[r.dataset.optionPos] = r.value;
          });
          /* Find matching variant option */
          for (var i = 0; i < variantSelect.options.length; i++) {
            var opt = variantSelect.options[i];
            var variant = JSON.parse(opt.dataset.variant || 'null');
            /* fallback: match by option values via label */
            var title = opt.textContent.trim();
            var parts = title.split(' / ');
            var match = Object.keys(vals).every(function (pos) {
              return parts[parseInt(pos, 10) - 1] === vals[pos];
            });
            if (match) {
              variantSelect.value = opt.value;
              variantSelect.dispatchEvent(new Event('change'));
              break;
            }
          }
        });
      });
    }

    /* ── Qty controls ── */
    var qtyInput = document.getElementById('vprod-qty');
    var qtyMinus = document.getElementById('vprod-qty-minus');
    var qtyPlus = document.getElementById('vprod-qty-plus');

    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10);
        if (v > 1) qtyInput.value = v - 1;
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }

    /* ── Choix 1, 2 ou 3 pots : règle la quantité ; masqué en abonnement (la remise ne vaut qu'en achat unique) ── */
    var lot = document.getElementById('vprod-lot');
    var qtyGroup = document.getElementById('vprod-qty-group');
    var lotOver = false;
    if (lot && qtyInput) {
      lot.querySelectorAll('.vprod__lot-radio').forEach(function (r) {
        r.addEventListener('change', function () {
          if (r.checked) qtyInput.value = r.value;
        });
      });
      document.querySelectorAll('.vprod__sub-radio').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var isSub = radio.value !== '';
          lot.hidden = isSub || lotOver;
          if (qtyGroup) qtyGroup.hidden = !(isSub || lotOver);
          var picked = lot.querySelector('.vprod__lot-radio:checked');
          qtyInput.value = (isSub || lotOver) ? 1 : (picked ? picked.value : 1);
        });
      });
    }

    /* ── Offre limitée : compte à rebours jusqu'à la fin des remises du lot, puis plus de lot ── */
    var deal = document.querySelector('.vprod__deal[data-lot-end]');
    if (deal && lot) {
      var dealEnd = parseInt(deal.dataset.lotEnd, 10) * 1000;
      var dealDate = deal.querySelector('[data-lot-date]');
      if (dealDate && window.Intl) {
        try {
          var dealDay = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { day: 'numeric', month: 'long', timeZone: 'Europe/Paris' }).format(new Date(dealEnd));
          dealDate.textContent = deal.dataset.until.replace('[date]', dealDay);
        } catch (err) {}
      }
      var cells = {};
      deal.querySelectorAll('[data-t]').forEach(function (c) { cells[c.dataset.t] = c; });
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var dealTimer = null;
      var dealTick = function () {
        var left = Math.max(0, Math.floor((dealEnd - Date.now()) / 1000));
        cells.d.textContent = pad(Math.floor(left / 86400));
        cells.h.textContent = pad(Math.floor(left % 86400 / 3600));
        cells.m.textContent = pad(Math.floor(left % 3600 / 60));
        cells.s.textContent = pad(left % 60);
        if (left > 0) return;
        clearInterval(dealTimer);
        lotOver = true;
        lot.hidden = true;
        if (qtyGroup) qtyGroup.hidden = false;
        if (qtyInput) qtyInput.value = 1;
      };
      dealTick();
      dealTimer = setInterval(dealTick, 1000);
    }

    /* ── Date de livraison estimée : jours ouvrés, sans les jours fériés français ── */
    var eta = document.getElementById('vprod-eta');
    if (eta && window.Intl) {
      var easter = function (y) {
        var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
        var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
        var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
        var n = h + l - 7 * m + 114;
        return new Date(y, Math.floor(n / 31) - 1, (n % 31) + 1);
      };
      var dayKey = function (dt) { return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate(); };
      var today = new Date();
      var holidays = {};
      [today.getFullYear(), today.getFullYear() + 1].forEach(function (y) {
        ['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25'].forEach(function (md) { holidays[y + '-' + md] = true; });
        var ea = easter(y);
        [1, 39, 50].forEach(function (offset) {
          var hd = new Date(ea);
          hd.setDate(hd.getDate() + offset);
          holidays[dayKey(hd)] = true;
        });
      });
      var addBusinessDays = function (from, count) {
        var dt = new Date(from);
        while (count > 0) {
          dt.setDate(dt.getDate() + 1);
          var wd = dt.getDay();
          if (wd !== 0 && wd !== 6 && !holidays[dayKey(dt)]) count--;
        }
        return dt;
      };
      var inFrance = (eta.dataset.country || 'FR') === 'FR';
      var minDays = parseInt(inFrance ? eta.dataset.min : eta.dataset.minEu, 10);
      var maxDays = parseInt(inFrance ? eta.dataset.max : eta.dataset.maxEu, 10);
      var dateLocale = { fr: 'fr-FR', en: 'en-GB', de: 'de-DE' }[eta.dataset.locale] || 'fr-FR';
      var fmt = new Intl.DateTimeFormat(dateLocale, { weekday: 'long', day: 'numeric', month: 'long' });
      eta.innerHTML = eta.dataset.text
        .replace('[start]', '<strong>' + fmt.format(addBusinessDays(today, minDays)) + '</strong>')
        .replace('[end]', '<strong>' + fmt.format(addBusinessDays(today, maxDays)) + '</strong>');
      eta.hidden = false;
    }

    /* ── Ajoute les deux : les deux articles d'un coup, puis le panier ── */
    var duoForm = document.getElementById('vprod-duo-form');
    if (duoForm && window.fetch) {
      duoForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var duoBtn = duoForm.querySelector('button');
        var ids = duoBtn.dataset.ids.split(',');
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        duoBtn.disabled = true;
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart');
          window.location.href = duoForm.dataset.cartUrl;
        }).catch(function () {
          duoBtn.disabled = false;
          duoForm.submit();
        });
      });
    }

    /* ── Abonnement : la fréquence choisie devient le plan envoyé au panier ── */
    var subPlan = document.getElementById('vprod-sub-plan');
    var subFreq = document.getElementById('vprod-sub-freq');
    var subPrice = document.getElementById('vprod-sub-price');
    if (subPlan && subFreq) {
      subFreq.addEventListener('change', function () {
        var opt = subFreq.options[subFreq.selectedIndex];
        subPlan.value = opt.value;
        subPlan.dataset.price = opt.dataset.price;
        if (subPrice) subPrice.textContent = opt.dataset.price;
        subPlan.checked = true;
        subPlan.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* ── Subscription: update displayed price on plan change ── */
    var subRadios = document.querySelectorAll('.vprod__sub-radio');
    var stickyPrice = document.getElementById('vprod-sticky-price');
    subRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
        if (stickyPrice && radio.dataset.price) stickyPrice.textContent = radio.dataset.price;
      });
    });

    /* ── Sticky mobile buy bar ── */
    var sticky = document.getElementById('vprod-sticky');
    var stickyBtn = document.getElementById('vprod-sticky-atc');
    var mainAtc = document.getElementById('vprod-atc');
    if (sticky && stickyBtn && mainAtc && 'IntersectionObserver' in window) {
      /* visible dès que le vrai bouton n'est pas à l'écran, au-dessus comme en dessous :
         le bouton d'achat est toujours à portée de pouce */
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var passed = !e.isIntersecting;
        sticky.classList.toggle('is-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        /* inert : sans lui, le bouton reste atteignable au clavier alors que
           la barre est masquee — un utilisateur au clavier tombe dans le vide. */
        if (passed) { sticky.removeAttribute('inert'); } else { sticky.setAttribute('inert', ''); }
      }, { threshold: 0 });
      io.observe(mainAtc);
      stickyBtn.addEventListener('click', function () {
        mainAtc.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-moments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-vrou]');
    if (!root) return;
    if (!('IntersectionObserver' in window)) { root.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { root.classList.add('is-visible'); io.disconnect(); }
    }, { threshold: 0.35 });
    io.observe(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-expansion-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var root = document.querySelector('[data-seh]');
    if (!root) return;
    var stage = root.querySelector('[data-seh-stage]');
    var reveal = root.querySelector('[data-seh-reveal]');
    var banners = root.querySelector('[data-seh-banners]');
    var carousel = banners ? banners.querySelector('[data-vbn], [data-vg3]') : null;
    var shelf = root.classList.contains('seh--shelf');
    var held = true;
    /* Le carrousel attend d'être affiché pour défiler et lancer ses vidéos */
    function releaseCarousel(show) {
      if (!carousel || show === !held) return;
      held = !show;
      if (show) {
        carousel.removeAttribute('data-hold');
        carousel.dispatchEvent(new CustomEvent('vbn:release'));
      } else {
        carousel.setAttribute('data-hold', '');
        carousel.dispatchEvent(new CustomEvent('vbn:hold'));
      }
      if ('inert' in banners) banners.inert = !show;
    }

    /* Vidéo : relance si le navigateur la met en pause (économie d'énergie).
       Si la lecture automatique est refusée (iPhone en mode économie de batterie),
       on revient à l'image fixe : sinon on voit la première image, qui est noire. */
    var video = root.querySelector('video.seh__media-el');
    if (video) {
      var gaveUp = false;
      var attempt = function () {
        if (gaveUp) return;
        var played = video.play();
        if (played && played.catch) {
          played.catch(function (err) {
            if (err && err.name === 'NotAllowedError' && document.visibilityState === 'visible') {
              gaveUp = true;
              /* Retirer la source laissait un écran noir sur Safari : on masque
                 simplement la vidéo, l'image de fond de .seh__media prend le relais. */
              video.style.display = 'none';
            }
          });
        }
      };
      video.addEventListener('pause', attempt);
      attempt();
    }

    /* Respect reduced motion: leave the static expanded fallback as-is. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      releaseCarousel(true);
      return;
    }

    function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

    /* Mobile : premier écran fixe, sauf avec les pots, où l'effet suit une course stable
       (hauteurs en lvh et svh, jamais la hauteur de la fenêtre, qui change avec la barre d'adresse). */
    var mobile = window.matchMedia('(max-width: 700px)');

    /* hauteur de l'en-tête collant (barre d'offres comprise), pour caler les calques épinglés dessous */
    var hdrEl = document.querySelector('.vn-header');
    hdrEl = hdrEl ? (hdrEl.closest('.shopify-section') || hdrEl) : null;
    function setHdr() { if (hdrEl) root.style.setProperty('--hdr', hdrEl.offsetHeight + 'px'); }
    setHdr();
    window.addEventListener('resize', setHdr, { passive: true });

    var ticking = false;
    var locked = false;
    function update() {
      ticking = false;
      var p;
      if (mobile.matches) {
        if (!(shelf && banners)) {
          if (banners) {
            banners.inert = false;
            if (held) releaseCarousel(true);
          }
          return;
        }
        var run = root.offsetHeight - stage.offsetHeight;
        if (run <= 0) return;
        /* distance parcourue par le premier écran collé */
        p = clamp((stage.getBoundingClientRect().top - root.getBoundingClientRect().top) / run, 0, 1);
      } else if (shelf && banners) {
        var travel = root.offsetHeight - stage.offsetHeight;
        if (travel <= 0) return;
        p = clamp((stage.getBoundingClientRect().top - root.getBoundingClientRect().top) / travel, 0, 1);
      } else {
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var runway = root.offsetHeight - vh;
        if (runway <= 0) return;
        /* progress through the pinned section: 0 at top, 1 when bottom reaches viewport */
        p = clamp(-rect.top / runway, 0, 1);
      }
      if (shelf && banners) {
        /* une fois la vitrine affichée, l'intro ne se rejoue plus quand on remonte */
        if (p >= 0.52) locked = true;
        if (locked) p = Math.max(p, 0.52);
      }
      var title = clamp(1 - p / 0.6, 0, 1);
      var rev = clamp((p - 0.55) / 0.4, 0, 1);
      stage.style.setProperty('--p', p.toFixed(4));
      stage.style.setProperty('--title', title.toFixed(4));
      stage.style.setProperty('--reveal', rev.toFixed(4));
      stage.style.setProperty('--reveal-events', rev > 0.5 ? 'auto' : 'none');
      if (shelf && banners) {
        /* le titre s'ouvre et découvre les pots, puis la gamme prend leur place :
           un seul coup de défilement en tout */
        var o = clamp(p / 0.36, 0, 1);
        stage.style.setProperty('--o', (1 - Math.pow(1 - o, 3)).toFixed(4));
        stage.style.setProperty('--v', clamp(1 - p / 0.16, 0, 1).toFixed(4));
        stage.style.setProperty('--title', clamp(1 - (p - 0.22) / 0.14, 0, 1).toFixed(4));
        stage.style.setProperty('--m', clamp((p - 0.3) / 0.2, 0, 1).toFixed(4));
        var bb = clamp((p - 0.32) / 0.2, 0, 1);
        root.style.setProperty('--b', bb.toFixed(4));
        root.style.setProperty('--b-events', bb > 0.6 ? 'auto' : 'none');
        releaseCarousel(bb > 0.6);
      } else if (banners) {
        /* Le titre part, le média s'efface, puis les bannières apparaissent et restent épinglées */
        /* Mêmes distances qu'avant pour arriver aux bannières, mais seulement ~25 % d'écran
           épinglé ensuite avant la section suivante */
        var titleOut = clamp(1 - p / 0.44, 0, 1);
        var m = clamp((p - 0.28) / 0.34, 0, 1);
        var b = clamp((p - 0.46) / 0.29, 0, 1);
        stage.style.setProperty('--title', titleOut.toFixed(4));
        stage.style.setProperty('--m', m.toFixed(4));
        root.style.setProperty('--b', b.toFixed(4));
        root.style.setProperty('--b-events', b > 0.6 ? 'auto' : 'none');
        releaseCarousel(b > 0.6);
      }
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
